module.exports = __webpack_public_path__ + "img/burger.6f1a2019.svg";